import React, { useState, useEffect } from "react";
import "./resetPassword.css";
import { Link } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { Container, Row, Col, Image } from "react-bootstrap";
import { TextFieldIcon } from "../Common/FormComponents/TextFieldIcon";
import * as Yup from "yup";
import { Formik, Form } from "formik";

function UpdatePassword(props) {
  const [pswrdVisible, setPswrdVisible] = useState(false);
  const [pswrdVisible1, setPswrdVisible1] = useState(false);

  const checkpswrdVisible = () => {
    setPswrdVisible(!pswrdVisible);
  };

  const checkpswrdVisible1 = () => {
    setPswrdVisible1(!pswrdVisible1);
  };

  const validate = Yup.object({
    username1: Yup.string().required("User id is required"),
  
    password1: Yup.string()
      .required("Password is required")
      .min(6, "Password must be at least 6 characters long")
      .matches(
        /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9]).*$/,
        "Password must contain at least one uppercase letter, one lowercase letter, and one number"
      ),  
    newPassword: Yup.string()
      .required("Password confirmation is required")
      .oneOf([Yup.ref("password1"), null], "Passwords must match"),
  });
  

  const isWindows = navigator.platform.includes("Win");

  const [emailFromUrl, setEmailFromUrl] = useState("");
  const [codeFromUrl, setCodeFromUrl] = useState("");

  const getQueryParamFromHash = (param) => {
    const hash = window.location.hash;
    const queryString = hash.includes("?") ? hash.split("?")[1] : "";
    const queryParams = new URLSearchParams(queryString);
    return queryParams.get(param) || "";
  };

  useEffect(() => {
    const handleHashChange = () => {
      setEmailFromUrl(getQueryParamFromHash("email"));
      setCodeFromUrl(getQueryParamFromHash("code"));
    };

    handleHashChange();
    window.addEventListener("hashchange", handleHashChange);
    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, []);

  return (
    <Formik
      enableReinitialize
      initialValues={{
        username1: emailFromUrl,
        password1: "",
        newPassword: "",
      }}
      validationSchema={validate}
      onSubmit={(values) => {
        const data = {
          userName: values?.username1,
          newPassword: values?.newPassword,
          salt: codeFromUrl,
        };

        props.resetPassword({ data });
      }}
    >
      {(formik) => (
        <div className={isWindows ? "backgroundscreenwin" : "backgroundscreen"}>
          <div className="backgroundbott mt-1">
            <Container>
              <div className="cardMainlogin">
                <Row>
                  <Col xs={12} md={12} sm={12} lg={6}>
                    <div>
                      <Image
                        alt="loginimage"
                        className="loginimage"
                        src={require("../../assets/img/Artboard_2.jpg")}
                      />
                    </div>
                  </Col>
                  <Col xs={12} md={12} sm={12} lg={6}>
                    <Container>
                      <div className="loginheaderfrst">
                        <div className="loginLogo">
                          <div>
                            <img
                              alt="logo1"
                              className="logo1"
                              src={require("../../assets/img/logo-sh.png")}
                            />
                          </div>
                          <div className="vl"></div>
                          <div>
                            <img
                              alt="logo2"
                              className="wateronlogo"
                              src={require("../../assets/img/waterOn_logo.png")}
                            />
                          </div>
                        </div>
                        <h3 className="loginTitle">Reset Password</h3>
                        <div className="loginform">
                          <Form>
                            <div>
                              <TextFieldIcon
                                placeholder="enter user id "
                                name="username1"
                                id="username1"
                                label="User Id"
                                type="text"
                                icon="fa fa-at textFieldicon"
                                autoComplete="new-password"
                                readOnly
                              />
                            </div>
                            <div>
                              <TextFieldIcon
                                placeholder="enter password"
                                name="password1"
                                label="Password"
                                type={pswrdVisible ? "text" : "password"}
                                icon="fa fa-unlock textFieldicon"
                                eyeicon={
                                  pswrdVisible
                                    ? "fa fa-eye-slash textFieldeyeicon"
                                    : "fa fa-eye textFieldeyeicon"
                                }
                                iconClick={checkpswrdVisible}
                                autoComplete="new-password"
                              />
                            </div>
                            <div>
                              <TextFieldIcon
                                placeholder="Re-Enter password"
                                name="newPassword"
                                label="Confirm Password"
                                type={pswrdVisible1 ? "text" : "password"}
                                icon="fa fa-unlock textFieldicon"
                                eyeicon={
                                  pswrdVisible1
                                    ? "fa fa-eye-slash textFieldeyeicon"
                                    : "fa fa-eye textFieldeyeicon"
                                }
                                iconClick={checkpswrdVisible1}
                                autoComplete="new-password"
                              />
                            </div>

                            <button className="contactpagebtn" type="submit">
                              Reset
                            </button>

                            <div className="para1div">
                              <p className="para1">
                                <Link to="/login" className="login-back-btn">
                                  Back to Login
                                </Link>
                              </p>
                            </div>
                          </Form>
                        </div>
                      </div>
                    </Container>
                  </Col>
                </Row>
              </div>
              <div className="footerclass">
                <div></div>
                <div className="loginDivVersion">
                  <span>
                    Copyright © {new Date().getFullYear()} by SmarterHomes
                    Private Ltd. All Rights Reserved.{" "}
                    {process.env.REACT_APP_VERSION}
                    {/* Version {packageJson.version}© {copyrightYear} SmarterHomes
                    Technologies */}
                  </span>
                </div>
              </div>
            </Container>
          </div>
        </div>
      )}
    </Formik>
  );
}

export default UpdatePassword;
